export default __webpack_public_path__ + "static/media/user_nonactive.3ccfa8a1.svg";